<script>
import Chart from 'chart.js/auto';
import palette from '@inscribe/signal/dist/palette';

let myChart;

export default {
  components: {},
  props: {
    data: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return { palette, chartColor: palette['light-primary-90'] };
  },
  watch: {
    data: {
      immediate: true,
      handler: function () {
        if (myChart) {
          myChart.destroy();
          this.createChart();
        }
      },
    },
  },
  mounted() {
    this.createChart();
  },

  methods: {
    getFont() {
      return {
        color: palette['light-neutral-110'],
        font: {
          family: '"Inter", Arial, Helvetica, sans-serif',
          size: 12,
          weight: 400,
        },
      };
    },
    createChart() {
      const chartCanvas = this.$refs.trustScoreChart;
      myChart = new Chart(chartCanvas, {
        data: {
          labels: this.data.map((a) => a.bucket),
          datasets: [
            {
              type: 'bar',
              data: this.data.map((d) => d.count),
              backgroundColor: this.chartColor,
              borderRadius: 0,
              borderColor: this.chartColor,
              borderWidth: 10,
              barPercentage: 0.7,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: false,
            tooltip: {
              displayColors: false,
              callbacks: {
                title(context) {
                  const index = context[0].dataIndex;
                  const count = context[0].dataset.data[index];
                  return `${count} ${count === 1 ? 'document' : 'documents'}`;
                },
                label(context) {
                  return `Trust Score: ${context.label}`;
                },
              },
            },
          },
          scales: {
            x: {
              title: {
                display: true,
                text: 'Trust Score',
                ...this.getFont(),
              },
              display: true,
              grid: {
                display: false,
              },
              type: 'category',
              ticks: {
                callback: (value) => (value % 5 === 0 ? value : null),
                stepSize: 5,
                ...this.getFont(),
              },
            },
            y: {
              beginAtZero: true,
              title: { display: true, text: 'Documents', ...this.getFont() },
              display: true,
              grid: {
                display: true,
              },
              ticks: {
                stepSize: 5,
                ...this.getFont(),
              },
            },
          },
        },
      });
    },
  },
};
</script>

<template>
  <div
    class="trust-score d-flex flex-row align-items-center justify-content-center"
  >
    <div class="chart">
      <canvas ref="trustScoreChart"></canvas>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.trust-score {
  width: 100%;

  .chart {
    width: 100%;

    canvas {
      width: 100%;
      height: 200px !important;
    }
  }
}
</style>
